import { render } from "./NominateVoteView.vue?vue&type=template&id=35562a74&scoped=true"
import script from "./NominateVoteView.vue?vue&type=script&lang=js"
export * from "./NominateVoteView.vue?vue&type=script&lang=js"

import "./NominateVoteView.vue?vue&type=style&index=0&id=35562a74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35562a74"

export default script